import { render, staticRenderFns } from "./TextBodySmall2.vue?vue&type=template&id=eb17e8fa&scoped=true"
import script from "./TextBodySmall2.vue?vue&type=script&lang=js"
export * from "./TextBodySmall2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb17e8fa",
  null
  
)

export default component.exports